<div class="row g-2">
  <div class="col col-md">
    <span class="text">
      {{ this.ts.getCurrentLanguage()['banner-cookie'] }}
      <a class="link" [href]="appConfig.cookiesLink" target="_blank"
        >"{{ this.ts.getCurrentLanguage()['cookie-policy'] }}"</a
      >.
    </span>
  </div>

  <div class="col-md-3">
    <div class="row g-2">
      <div class="col-6 col-md-12">
        <app-button
          text="{{ this.ts.getCurrentLanguage()['cookie-accept'] }}"
          buttonType="dark"
          styleType="outlined"
          sizeType="small"
          width="100%"
          [height]="!screenService.isMobileScreen() ? null : '3rem'"
          (click)="appTrackingService.setAcceptCookies(true)"
        ></app-button>
      </div>

      <div class="col-6 col-md-12">
        <app-button
          text="{{ this.ts.getCurrentLanguage()['cookie-reject'] }}"
          buttonType="dark"
          styleType="outlined"
          sizeType="small"
          width="100%"
          [height]="!screenService.isMobileScreen() ? null : '3rem'"
          (click)="appTrackingService.setAcceptCookies(false)"
        ></app-button>
      </div>
    </div>
  </div>
</div>
